import type {LucideIcon} from "lucide-react";

const StatCard = ({
  isLoading,
  title,
  value,
  icon: Icon,
}: {
  isLoading: boolean;
  title: string;
  value: string | number;
  icon: LucideIcon;
}) => {
  return (
    <div className="stats bg-base-100 flex-1">
      <div className="stat">
        {isLoading ? (
          <div className={"skeleton w-full h-20"}></div>
        ) : (
          <>
            <div className="stat-figure"><Icon /></div>
            <div className="stat-title">{title}</div>
            <div className="stat-value">{value}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default StatCard;
